var shipping_amount = window.shipping_amount_number; // Set the shipping amount threshold

window.updateProgressBarShipping = function (domRender, price) {
  var progressIndicator_shipping = domRender.querySelectorAll(
    ".progress-indicator_shipping",
  );
  var shipping_text = domRender.querySelectorAll(".shipping_text");
  var free_shipping_text = domRender.querySelectorAll(".free_shipping_text");

  let progress = Math.min((price / shipping_amount) * 100, 100); // Calculate progress (max 100%)

  if (price >= shipping_amount) {
    let messageLast = `¡El pedido es apto para envío gratuito!`;
    shipping_text.forEach((el) => (el.innerHTML = messageLast));
    free_shipping_text.forEach((el) => (el.innerText = "Gratis"));
  } else {
    let remaining = (shipping_amount - price).toLocaleString();
    let message = `¡Agregá <strong>$${remaining}</strong> más para <strong>el envío gratuito!</strong>`;
    shipping_text.forEach((el) => (el.innerHTML = message));
  }

  progressIndicator_shipping.forEach((el) => {
    el.style.width = `${progress}%`;
    el.style.backgroundColor = progress >= 100 ? "#27800b" : "#000000";
  });
};
